import { Link, useLocation } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();
  usePageMeta("页面未找到 - 美味的快递", "抱歉，你访问的页面不存在，返回首页继续浏览美食外卖与快递服务。");

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className="ri-emotion-sad-line text-4xl" />
      </span>
      <p className="mt-6 font-heading text-6xl font-black text-primary-500 md:text-8xl">404</p>
      <h1 className="mt-4 font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">这个页面走丢啦</h1>
      <p className="mt-3 max-w-md text-sm text-foreground-500">
        你访问的地址 <span className="font-mono text-foreground-700">{location.pathname}</span> 不存在，不如回去看看今天想吃点什么。
      </p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-sm font-bold text-background-50 transition hover:bg-primary-600"
        >
          <i className="ri-home-5-line" />
          返回首页
        </Link>
        <Link
          to="/food-category"
          className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-primary-300 bg-background-50 px-7 py-3.5 text-sm font-bold text-primary-700 transition hover:bg-primary-50"
        >
          <i className="ri-restaurant-2-line" />
          去逛逛美食
        </Link>
      </div>
    </div>
  );
}